import { ProductFactoryConfig } from './product-factory.config';
import { ProductApiServiceAbstract } from '../domain/repository/product-api.service.abstract';

export const productFactory = (productApiService: ProductApiServiceAbstract) =>
  new ProductFactoryConfig(productApiService).initProductUseCases();
